var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.tagName,{tag:"component",staticClass:"px-4 py-3 font-medium transition duration-150 border-2",class:_vm.disabled ? _vm.classNames.disabled : _vm.enabledClassNames,attrs:{"disabled":_vm.disabled,"to":_vm.to}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }